import { gql } from 'apollo-boost';

import {
  instantPromotionFields,
  potentialPromotionsFragment
} from './potential-promotions-fragment';

const stoppingFields = gql`
        fragment stoppingFields on StoppingData {
          wetRating
          wetDistance
          wetWornDistance
          rollingResistanceRating
          dryDistance
          dryRating
          winterRating
        }
      `;

const compareByCodesFields = gql`
  fragment compareByCodesFields on ProductData {
    addToCartDisabled
    articleStatus
    baseprice {
      formattedValue
      value
    }
    brand
    brandLogo {
      url
    }
    code
    description
    freeShipping
    gbb
    images {
      url
      altText
      format
    }
    loadCapacity
      mapPrice {
      currencyIso
      formattedValue
      priceType
      value
    }
    mapDisplayRule {
      messageDisplay
      mapPriceDisplay
      message
    }
    mapRuleSatisfied
    manufacturerMileageWarranty
    markdownPriceData {
      formattedPercentageSaved
      originalRetailValue
    }
    maxAirPressure
    mileageWarranty
    name
    price {
      formattedValue
      value
    }
    priceRange {
      minPrice {
        value
      }
      maxPrice {
        value
      }
    }
    productType
    potentialPromotions {
      ...potentialPromotionsFragment
    }
    reviewSummaryData {
      totalCount
      totalRating
    }
    recommendationData {
      tireLifeYears
      tireLifeMonths
      code
      milesPerDollar
      stopping {
        ...stoppingFields
      }
      rank
      rideRating {
        handling
        quiet
        comfort
        wetHandling
      }
      mileage {
        warranty
        min
        median
      }
    }
    rimWidth
    size
    speedRating
    stock {
      showCheckNearbyStoresLink
      stockCount
      availabilityMessage
      availabilityMessageRank
    }
    tempGrade
    tireAspectRatio
    tireCrossSection
    tireDiameter
    tireWheelRimDiameter
    tractionGrade
    treadDepth
    treadGrade
    treadWidth
    grossWeight
    unitName
    url
    wheelRimDiameter
    widthRange
  }
  ${stoppingFields}
  ${potentialPromotionsFragment}
  ${instantPromotionFields}
`;

export const COMPARE_STAGGERED_PRODUCT_QUERY = gql`
  query compareProductData(
    $storeCode: String!
    $treadwellRequest: TreadwellRequest
    $vehicleInfo: VehicleInput
    $zipCode: String
    $productCodes: [ProductCode]!
  ) {
    product {
      averageRatings(productCodes: $productCodes) {
        overallRating
        averageRatings {
          value
          key
        }
        recommendedPercentage
        totalReviews
      }

      byCodes(
        treadwellRequest: $treadwellRequest
        vehicleInfo: $vehicleInfo
        productCodes: $productCodes
        storeCode: $storeCode
      ) {
        ...compareByCodesFields
        freeShipping
        isOtherVehiclesOE
        rearProduct {
          addToCartDisabled
          articleStatus
          code
          brand
          brandLogo {
            url
          }
          images {
            url
            altText
            format
          }
          gbb
          grossWeight
          mapDisplayRule {
            mapPriceDisplay
            message
            messageDisplay
          }
          mapPrice {
            currencyIso
            formattedValue
            priceType
            value
          }
          mapRuleSatisfied
          markdownPriceData {
            formattedPercentageSaved
            originalRetailValue
          }
          potentialPromotions {
            ...potentialPromotionsFragment
          }
          productType
          price {
            formattedValue
            value
          }
          rimWidth
          size
          tireAspectRatio
          tireCrossSection
          tireDiameter
          tireWheelRimDiameter
          widthRange
        }
      }
    }
    recommendationQueries {
      weatherDetails(zipCode: $zipCode) {
        winterDaysPerYear
        precipitationDaysPerYear
      }
    }
  }
  ${compareByCodesFields}
  ${potentialPromotionsFragment}
`;

export const COMPARE_STANDARD_PRODUCT_QUERY = gql`
  query compareProductData(
    $storeCode: String!
    $treadwellRequest: TreadwellRequest
    $vehicleInfo: VehicleInput
    $zipCode: String
    $productCodes: [String]!
  ) {
    product {
      averageRatingsStandard(productCodes: $productCodes) {
        overallRating
        averageRatings {
          value
          key
        }
        recommendedPercentage
        totalReviews
      }

      byCodesStandard(
        treadwellRequest: $treadwellRequest
        vehicleInfo: $vehicleInfo
        productCodes: $productCodes
        storeCode: $storeCode
      ) {
        ...compareByCodesFields
        freeShipping
        isOtherVehiclesOE
      }
    }
    recommendationQueries {
      weatherDetails(zipCode: $zipCode) {
        winterDaysPerYear
        precipitationDaysPerYear
      }
    }
  }
  ${compareByCodesFields}
`;
